import httpManager from "@/app/shared/utils/httpManager";

export async function createNoContactEquivalencies(portfolioId, body) {
  const response = await httpManager.post(`/portfolios/${portfolioId}/equivalences-nc/`, body);

  return response.data;
}
